// Define the slides, with some containing scene-specific content
export const slides = [
    { type: 'image', heading: 'COVER', content: './presentation/Blue Rock Mine_2025_page-0001.jpg' },
    {
      type: 'scene',
      heading: 'Overview',
      content: {
        visibleObjects: ['SATELLITE'],
        cameraPosition: [ 793647,5507 ,-7977223],
        lookAt: [793647, 1076,-7978940],
        description:`<strong>OVERVIEW<strong> `
      }
    },
    {
      type: 'scene',
      heading: 'WHITEHEATHER',
      content: {
        visibleObjects: ['SATELLITE','Surface','Underground'],
        cameraPosition: [ 793647,5507 ,-7977223],
        lookAt: [793647, 1076,-7978940],
        description:`<strong>OVERVIEW<strong> `
      }
    },
    {
      type: 'scene',
      heading: 'WORKINGS',
      content: {
        visibleObjects: ['Surface','Underground'],
        cameraPosition: [ 793912,1422 ,-7978992],
        lookAt: [794116, 995,-7978865],
        description:`<strong>OVERVIEW<strong> `
      }
    }
    ,{ type: 'image', heading: 'DISCUSSION', content: './presentation/Blue Rock Mine_2025_page-0019.jpg' }
  ];